import { UserContext } from 'components/contexts/UserProvider';
import { getKeycloakUserData } from 'lib/api_ts/keycloakApi';
import { useContext, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom-v5-compat';

const LoginSSO = () => {
	const { loginContext } = useContext(UserContext);
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [params, _] = useSearchParams();
	const navigate = useNavigate();
	const code = params.get('code');

	useEffect(() => {
		// if (done) return;
		if (code && loginContext) {
			(async () => {
				const userData = await getKeycloakUserData(code);

				if (userData && userData.token) {
					localStorage.setItem('token', userData.token);
					localStorage.setItem('userEmail', userData.email);
					localStorage.setItem('userFirstname', userData.firstName);
					localStorage.setItem('userLastname', userData.lastName);
					if (!localStorage.getItem('userLanguage')) {
						localStorage.setItem('userLanguage', 'IT');
					}
					localStorage.setItem('keycloakLogin', 'true');
					loginContext(userData);
					navigate('/projects');
				}
			})();
		}
	}, [code, navigate, loginContext]);
};

export default LoginSSO;
